const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const GlossaryLetterFilter = ({
  activeLetter,
  availableLetters,
  onChange,
  allLabel = 'Vše',
  filterLabel = 'Filtr:'
}) => {
  return (
    <div className="flex items-center gap-3 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
      <span className="text-grey-600 shrink-0 text-sm font-medium">{filterLabel}</span>

      <button
        type="button"
        onClick={() => onChange('all')}
        aria-pressed={activeLetter === 'all'}
        className={`shrink-0 rounded-[10px] border px-3 py-1.5 text-sm font-medium transition-colors ${
          activeLetter === 'all'
            ? 'border-brand-500 bg-brand-500 text-white'
            : 'border-grey-200 text-grey-700 hover:border-grey-300 bg-white'
        }`}
      >
        {allLabel}
      </button>

      <div className="flex shrink-0 gap-1.5">
        {ALPHABET.map((letter) => {
          const isAvailable = availableLetters.has(letter);
          const isActive = activeLetter === letter;

          return (
            <button
              key={letter}
              type="button"
              disabled={!isAvailable}
              onClick={() => isAvailable && onChange(letter)}
              aria-pressed={isActive}
              className={`flex h-[34px] w-[34px] items-center justify-center rounded-[10px] border text-sm font-medium transition-colors ${
                isActive
                  ? 'border-brand-500 bg-brand-500 text-white'
                  : isAvailable
                    ? 'border-grey-200 text-grey-700 hover:border-grey-300 bg-white'
                    : 'border-grey-200 text-grey-400 cursor-default bg-white opacity-30'
              }`}
            >
              {letter}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GlossaryLetterFilter;
